import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitUnfilledRecoveryDTO } from 'features/inventory/api/types/adUnitUnfilledRecoveryDTO'
import { AdUnitUnfilledRecovery } from 'features/inventory/types/adUnitUnfilledRecovery'

type From = AdUnitUnfilledRecoveryDTO
type To = AdUnitUnfilledRecovery

export const adUnitUnfilledRecoveryFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ allowMultiformatEnabled }: From): To => ({
      allowMultiformatEnabled,
    }),
  )
